import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60fe0c90"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "select-list__area",
  tabindex: "0"
}
const _hoisted_2 = {
  key: 0,
  class: "select-list__area-left-slot"
}
const _hoisted_3 = { class: "select-list__desc-select" }
const _hoisted_4 = { class: "select-list__label" }
const _hoisted_5 = { class: "select-list__placeholder" }
const _hoisted_6 = {
  key: 1,
  class: "select-list__area-right-slot"
}
const _hoisted_7 = { class: "select-list__icon-open" }
const _hoisted_8 = { class: "select-list__options" }

import { computed, PropType, ref, useSlots } from "vue";
import { ChevronDownIcon } from "tir-style-system/icons/solid";
import { PopoverPositionEnum, PopoverPositionType, TirPmPopover } from "tir-pm-popover";
import { TirPmScrollbar } from "tir-pm-scrollbar";


export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmSelect',
  props: {
  /**Позиция поповера */
  popoverPosition: {
    type: [String, Object] as PropType<PopoverPositionEnum | PopoverPositionType>,
    default: (): PopoverPositionType => ({
      top: " $el:height ",
      left: "0rem",
      right: "0rem",
    }),
  },

  /**
   * Максимальная высота контента
   */
  maxHeightContent: {
    type: String as PropType<string>,
    default: "12",
  },

  /**
   * Уменьшенный по высоте
   */
  isReduced: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Состояние ошибки
   */
  isWithError: {
    type: Boolean as PropType<boolean>,
  },
  /**
   * Клик оусайд
   */
  isUseClickOutside: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  /**
   * Лейбл
   */
  label: { type: String as PropType<string>, default: "Элементы" },
  /**
   * Подсказка
   */
  hintMassage: { type: String as PropType<string>, default: "" },
  /**
   * Показывать ли подсказку
   */
  isShowHintMassage: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Дизейбл
   */
  isDisabled: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Плейсхолдер
   */
  placeholder: {
    type: String as PropType<string>,
    default: "Выберите значение",
  },
},
  emits: ["update", "toggleVisibleOptions", "focus", "blur"],
  setup(__props, { emit }) {

const props = __props;




/**
 * Пропсы
 */


const slots = useSlots();

/**
 * Вычисляемый контент
 */
const isSelectedContent = computed(() => slots && slots.selectedContent && slots.selectedContent());

/**
 * Есть ли слот слева
 */
const isLeft = computed(() => slots && slots.leftInArea && slots.leftInArea());
/**
 * Есть ли слот справа
 */
const isRight = computed(() => slots && slots.rightInArea && slots.rightInArea());

/**
 * Элемент селекта
 */
let $selectList = ref(null);

/**
 * Элемент поповера
 */
const $popover = ref(null);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmPopover), {
    position: _unref(PopoverPositionEnum).Bottom,
    customPosition: props.popoverPosition,
    ref_key: "$popover",
    ref: $popover,
    isDisabled: props.isDisabled
  }, {
    default: _withCtx(({ isOpened }) => [
      _createElementVNode("div", {
        class: _normalizeClass(["select-list", {
          'select-list--selected': isSelectedContent.value,
          'select-list--opened': isOpened,
          'select-list--with-hint': props.hintMassage,
          'select-list--error': props.isWithError,
          'select-list--disabled': props.isDisabled,
          'select-list--reduced': props.isReduced,
        }]),
        ref_key: "$selectList",
        ref: $selectList
      }, [
        _createElementVNode("div", _hoisted_1, [
          (isLeft.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "leftInArea")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(props.label), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["select-list__selected-item", {
                'select-list__selected-item--show': isOpened || isSelectedContent.value,
                'select-list__selected-item--disabled': props.isDisabled,
              }])
            }, [
              _renderSlot(_ctx.$slots, "selectedContent", {}, () => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(props.placeholder), 1)
              ])
            ], 2)
          ]),
          (isRight.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "rightInArea")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(ChevronDownIcon))
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["select-list__hint-massage", {
            'select-list__hint-massage--show': props.isShowHintMassage && !isOpened,
          }])
        }, _toDisplayString(props.hintMassage), 3)
      ], 2)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _renderSlot(_ctx.$slots, "contentTop", {
          open: $popover.value.open,
          close: $popover.value.close
        }),
        _createVNode(_unref(TirPmScrollbar), {
          style: _normalizeStyle({ 'max-height': props.maxHeightContent + 'rem' })
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "content", {
              open: $popover.value.open,
              close: $popover.value.close
            })
          ]),
          _: 3
        }, 8, ["style"]),
        _renderSlot(_ctx.$slots, "contentBottom", {
          open: $popover.value.open,
          close: $popover.value.close
        })
      ])
    ]),
    _: 3
  }, 8, ["position", "customPosition", "isDisabled"]))
}
}

})